<template>
    <div class="container-fluid">
        <header class="member-page-heading">
            <div>
                <h1 id="member-directory-title">Member directory</h1>
                <p>Find member details, manage account access, and record merchandise collection.</p>
            </div>
        </header>

        <MemberList></MemberList>
    </div>

</template>

<script>
import {defineComponent} from 'vue'
import MemberList from "@/components/master/MemberList.vue";

export default defineComponent({
    name: "MemberPage",
    components: {
        MemberList
    }
})
</script>


<style scoped>
.member-page-heading {
    margin: 0 0 1.5rem;
}

.member-page-heading h1 {
    margin: 0;
    color: #1f2937;
    font-size: 1.75rem;
    font-weight: 700;
    letter-spacing: -0.025em;
}

.member-page-heading p {
    margin: 0.35rem 0 0;
    color: #6b7280;
    font-size: 0.95rem;
}

@media (max-width: 575.98px) {
    .member-page-heading {
        margin-bottom: 1rem;
    }

    .member-page-heading h1 {
        font-size: 1.5rem;
    }
}

</style>
